import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import ProtectedRoute from './components/common/ProtectedRoute';

// Pages
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import RiskAssessment from './pages/RiskAssessment';
import Portfolio from './pages/Portfolio';
import SIPPlanner from './pages/SIPPlanner';
import CorpusProjection from './pages/CorpusProjection';
import MarketData from './pages/MarketData';
import Backtest from './pages/Backtest';
import RebalancingAlertHistory from './pages/RebalancingAlertHistory';

// Auth components
import Login from './components/auth/Login';
import Register from './components/auth/Register';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50 flex flex-col">
          <Navbar />
          <main className="flex-1">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />

              {/* Protected Routes */}
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/risk-assessment" element={<ProtectedRoute><RiskAssessment /></ProtectedRoute>} />
              <Route path="/portfolio" element={<ProtectedRoute><Portfolio /></ProtectedRoute>} />
              <Route path="/sip-planner" element={<ProtectedRoute><SIPPlanner /></ProtectedRoute>} />
              <Route path="/corpus-projection" element={<ProtectedRoute><CorpusProjection /></ProtectedRoute>} />
              <Route path="/market-data" element={<ProtectedRoute><MarketData /></ProtectedRoute>} />
              <Route path="/backtest" element={<ProtectedRoute><Backtest /></ProtectedRoute>} />
              <Route path="/rebalancing" element={<ProtectedRoute><RebalancingAlertHistory /></ProtectedRoute>} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
